/**
 * <s-more-reviews> — Shows hidden review cards 10 at a time.
 *
 * Markup: cards past the first batch carry [data-more-hidden] + hidden; the button is [data-more-button].
 * Each tap reveals the next batch (step attribute, default 10), fades them in, and moves focus to the first new card.
 * When none are left the button is removed and the optional [data-more-done] link shows.
 */
class SMoreReviews extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-more-button]');
    this.button?.addEventListener('click', () => this.#reveal());
  }

  #reveal() {
    const step = parseInt(this.getAttribute('step'), 10) || 10;
    const next = [...this.querySelectorAll('[data-more-hidden]')].slice(0, step);
    next.forEach((card, i) => {
      card.removeAttribute('data-more-hidden');
      card.hidden = false;
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        card.animate(
          [{ opacity: 0, transform: 'translateY(12px)' }, { opacity: 1, transform: 'none' }],
          { duration: 420, delay: Math.min(i, 9) * 40, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'backwards' }
        );
      }
    });
    if (next[0]) {
      next[0].setAttribute('tabindex', '-1');
      next[0].focus({ preventScroll: true });
    }
    if (!this.querySelector('[data-more-hidden]')) {
      this.button.remove();
      const done = this.querySelector('[data-more-done]');
      if (done) done.hidden = false;
    }
  }
}

if (!customElements.get('s-more-reviews')) customElements.define('s-more-reviews', SMoreReviews);
